'use strict';

module.exports = {
  // SDK Modes
  LOCALHOST_MODE: 'localhost',
  STANDALONE_MODE: 'standalone',
  PRODUCER_MODE: 'producer',
  CONSUMER_MODE: 'consumer',
  // Storage types
  STORAGE_MEMORY: 'MEMORY',
  STORAGE_REDIS: 'REDIS',
  STORAGE_LOCALSTORAGE: 'LOCALSTORAGE'
};


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/utils/constants/index.js
// module id = 80
// module chunks = 7